import React from "react";
import { createPortal } from "react-dom";
import { FiAlignLeft } from "react-icons/fi";
import { Link } from "react-router-dom";
import DropdownUser from "./DropdownUser";
import DropdownNotification from "./DropdownNotification";
import HeaderMenu from "./HeaderMenu";
import logo from "../../assets/images/icon-dark.png";

{
  /* Start of Header component */
}
const Header: React.FC = () => {
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const headerRef = React.useRef<HTMLElement>(null);
  const [headerH, setHeaderH] = React.useState(64);

  React.useEffect(() => {
    if (headerRef.current) setHeaderH(headerRef.current.offsetHeight);
  }, []);

  return (
    <>
      <header ref={headerRef} className="sticky top-0 z-50 w-full bg-white drop-shadow dark:bg-boxdark dark:drop-shadow-none">
        <div className="flex items-center justify-between py-3 px-4">

          {/* Mobile hamburger - left */}
          <button className="block lg:hidden text-xl p-2" onClick={() => setMobileOpen(o => !o)}>
            <FiAlignLeft className={mobileOpen ? "text-[#6c5ffc]" : "text-[#64748B]"} />
          </button>

          {/* Logo - center on mobile, left on desktop */}
          <Link className="absolute left-1/2 -translate-x-1/2 lg:static lg:translate-x-0 flex-shrink-0" to="/">
            <img src={logo} alt="DBI360" className="h-12 w-auto" />
          </Link>

          {/* Desktop menu */}
          <div className="hidden lg:flex flex-1 items-center">
            <HeaderMenu />
          </div>

          {/* Right section */}
          <div className="flex items-center gap-4">
            <DropdownNotification />
            <DropdownUser />
          </div>
        </div>
      </header>

      {/* Mobile sidebar rendered at body level via portal */}
      {createPortal(
        <>
          {/* Overlay */}
          <div
            onClick={() => setMobileOpen(false)}
            className={`fixed left-0 right-0 bottom-0 z-[9998] bg-black/40 transition-opacity duration-300 ${
              mobileOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
            }`}
            style={{ top: headerH }}
          />
          {/* Sidebar */}
          <div
            className={`fixed left-0 bottom-0 z-[9999] w-[270px] bg-white transition-transform duration-300 ease-in-out shadow-[4px_0_16px_rgba(0,0,0,0.12)] overflow-y-auto ${
              mobileOpen ? "translate-x-0" : "-translate-x-full"
            }`}
            style={{ top: headerH + 12 }}
          >
            {/* Sidebar menu */}
            <div className="pt-3 pr-2 pb-3 pl-[18px]">
              <HeaderMenu mobile onClose={() => setMobileOpen(false)} />
            </div>
          </div>
        </>,
        document.body
      )}
    </>
  );
};
{
  /* End of Header component */
}

export default Header;